
































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionDelivery } from "../../../../domain/workflow/reception";
import { WorkflowCommonMixin } from "../../mixins";

@Component({
  components: {}
})
export default class ReceptionDeliveryView extends Mixins(WorkflowCommonMixin) {
  @Prop()
  delivery: ReceptionDelivery;

  @Prop()
  generalFlag1Label: string;

  get type(): string {
    if (this.delivery) {
      return this.delivery.type.name;
    }
  }

  get generalFlag1(): boolean {
    return this.delivery ? this.delivery.generalFlag1 : false;
  }

  get zipCode(): string {
    return this.delivery ? this.delivery.zipCode : "";
  }

  get address(): string {
    return this.delivery ? this.delivery.address : "";
  }

  get note(): string {
    return this.delivery ? this.delivery.note : "";
  }
}
